
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import ProjectGallery from '@/components/feature/ProjectGallery';
import { allProjects } from '@/mocks/projects';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Main Content */}
      <main className="pt-20">
        {/* Projects Gallery - Full Width */}
        <section className="pb-16">
          <div className="w-full">
            <ProjectGallery projects={allProjects} />
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
